import { createFetcher } from '../../Common';

import { millisecondToDate, queryBuilder } from '../../utils';

import { CALENDAR_EVENTS_ENDPOINT, CALENDARS_ENDPOINT, getBaseUrl } from '../../constants';

/**
 * Creates a new Person.
 * @Positions
 */
export class CalendarEvents {
  static getInstance() {
    if (!this.instance) {
      this.instance = new CalendarEvents(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = CALENDAR_EVENTS_ENDPOINT;
    this.fetcher = fetcher;
    this.calendar = CALENDARS_ENDPOINT;
  }

  get base_url() {
    return getBaseUrl();
  }
  /**
   * this function is to get All events of calendar
   * @function getAllEvents
   ** @param {reqParam} default parameter
   */

  async getAllEvents(reqParam) {
    const queryString = queryBuilder(reqParam);
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }

  async getAllCalendars() {
    const url = `${this.base_url}${this.calendar}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }

  async getEventsByUserID(reqParam) {
    let query = '';
    if (reqParam?.date) {
      query = `startDate=${millisecondToDate(reqParam?.date)}&endDate=${millisecondToDate(
        reqParam?.date
      )}`;
    }
    const url = `${this.base_url}${this.endpoint}/${reqParam?.userID}${query ? `?${query}` : ''}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }
}

export const createCalenderEvents = () => CalendarEvents.getInstance();
